import styled from 'styled-components';

export const Container = styled.h2`
	margin-bottom: 0.75rem;

	font: var(--body-xl-500);
`;
